import { render, staticRenderFns } from "./c-pre-release-table.vue?vue&type=template&id=9e04db52&scoped=true"
import script from "./c-pre-release-table.vue?vue&type=script&lang=js"
export * from "./c-pre-release-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e04db52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e04db52')) {
      api.createRecord('9e04db52', component.options)
    } else {
      api.reload('9e04db52', component.options)
    }
    module.hot.accept("./c-pre-release-table.vue?vue&type=template&id=9e04db52&scoped=true", function () {
      api.rerender('9e04db52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/pre-release/c-pre-release-table.vue"
export default component.exports